import React from 'react';
import { useDispatch } from 'react-redux';
import { generarFacturaLocalNacional } from '../../store/slices/despachoNacionalesSlice';
import './PreviewFacturaLocalModal.css';

const PreviewFacturaLocalModal = ({ isOpen, invoiceData, pedidoId, fecha, onClose, isGenerating }) => {
  const dispatch = useDispatch();

  if (!isOpen || !invoiceData) {
    return null;
  }

  const handleGenerate = () => {
    dispatch(generarFacturaLocalNacional({ pedidoId, fecha }));
    onClose();
  };

  const formatCurrency = (amount) => {
    return new Intl.NumberFormat('es-CL', {
      style: 'currency',
      currency: 'CLP',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    }).format(amount);
  };

  const { cliente, items, subtotal, iva, total } = invoiceData;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>Vista Previa - Factura Local</h2>
          <button className="close-btn" onClick={onClose}>×</button>
        </div>

        <div className="modal-body">
          {/* Cliente Section */}
          <div className="section">
            <h3>Cliente</h3>
            <div className="client-info">
              <div className="info-row">
                <span className="label">RUT:</span>
                <span className="value">{cliente?.rut || 'N/A'}</span>
              </div>
              <div className="info-row">
                <span className="label">Nombre:</span>
                <span className="value">{cliente?.nombre || 'N/A'}</span>
              </div>
            </div>
          </div>

          {/* Products Section */}
          <div className="section">
            <h3>Productos</h3>
            <table className="products-table">
              <thead>
                <tr>
                  <th>Producto</th>
                  <th className="text-right">Cantidad</th>
                  <th className="text-right">Precio Unit.</th>
                  <th className="text-right">Total</th>
                </tr>
              </thead>
              <tbody>
                {items && items.map((item, index) => (
                  <tr key={index}>
                    <td>{item.producto}</td>
                    <td className="text-right">{item.cantidad} cajas</td>
                    <td className="text-right">{formatCurrency(item.precioUnitario)}</td>
                    <td className="text-right">{formatCurrency(item.total)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {/* Totals Section */}
          <div className="section">
            <h3>Totales</h3>
            <div className="totals-info">
              <div className="total-row">
                <span className="label">Subtotal:</span>
                <span className="value">{formatCurrency(subtotal)}</span>
              </div>
              <div className="total-row">
                <span className="label">IVA (19%):</span>
                <span className="value">{formatCurrency(iva)}</span>
              </div>
              <div className="total-row total-final">
                <span className="label">Total:</span>
                <span className="value">{formatCurrency(total)}</span>
              </div>
            </div>
          </div>
        </div>

        <div className="modal-footer">
          <button 
            className="btn btn-secondary" 
            onClick={onClose}
            disabled={isGenerating}
          >
            Cancelar
          </button>
          <button 
            className="btn btn-primary" 
            onClick={handleGenerate}
            disabled={isGenerating}
          >
            {isGenerating ? 'Generando...' : 'Generar Factura Local'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default PreviewFacturaLocalModal;
